export default "__VITE_ASSET__BmlJsAWB__"